import { observable, action } from "mobx";
import { PATH_READ_DATI_UTENTE, PATH_SAVE_DATI_UTENTE } from "../config/presdoc-fe-config";

class UtenteStore {

  constructor(root) {
    this.service = root.service
    this.tipologicaStore = root.tipologicaStore;
  }


  @observable utente = {}; //utente utilizzato dai DATI UTENTE
  


  @action
  readDatiUtente(callback) {
    this.service.doAjax('GET', PATH_READ_DATI_UTENTE).then(response => {       
      if (response.success) {
        let result = response.result.sezioneIdentificata.sezione    
        this.utente = {...result};
      }
      callback && callback(this.utente);
    })
  }
  
  @action
  saveDatiUtente(utente, callback) {
    let json = {
      utente
    }
    this.service.doAjax('POST', PATH_SAVE_DATI_UTENTE, json).then(response => {       
      if (response.success) {
        this.utente = {
          ...utente
        }
      }
      callback && callback(response);
    })
  }

  @action
  cleanUtente() {
    this.utente = {};
  }

}

export default UtenteStore;